var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlertInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#FEE2E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9998 37.3332C16.636 37.3332 10.6665 31.3636 10.6665 23.9998C10.6665 16.636 16.636 10.6665 23.9998 10.6665C31.3636 10.6665 37.3332 16.636 37.3332 23.9998C37.3251 31.3603 31.3603 37.3251 23.9998 37.3332ZM13.3332 24.2292C13.3963 30.0975 18.188 34.8126 24.0566 34.7812C29.9251 34.7495 34.6659 29.9832 34.6659 24.1145C34.6659 18.2458 29.9251 13.4795 24.0566 13.4478C18.188 13.4164 13.3963 18.1315 13.3332 23.9998V24.2292ZM26.6665 30.6665H22.6665V25.3332H21.3332V22.6665H25.3332V27.9998H26.6665V30.6665ZM25.3332 19.9998H22.6665V17.3332H25.3332V19.9998Z",
    fill: "#DB0A3C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertInfo);
export default __webpack_public_path__ + "static/media/alert-info.29153f1f.svg";
export { ForwardRef as ReactComponent };